export default (theme) => ({
  container: {
    padding: '5px'
  },
  header: {
    fontWeight: 'lighter'
  },
  divider: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2
  }
})
